export default __webpack_public_path__ + "static/media/picture.fbd2d384.jpg";